import { useTranslation } from 'react-i18next';
import useUser from '../../authentication/context/useUser';

const useReportCoverTexts = (
  pageType: 'complete' | 'simple',
  year?: number,
) => {
  const { t } = useTranslation('project');
  const { user } = useUser();

  const title = t(`project:pdf.reportCover.${pageType}.title`, { year });
  const subtitle = t(`project:pdf.reportCover.${pageType}.subtitle`);
  const companyText = user?.company?.toUpperCase() || '';
  const jyrosSubtitle = t('project:pdf.reportCover.jyrosSubtitle');
  const homologationText = t('project:pdf.reportCover.homologationText');

  return {
    title,
    subtitle,
    companyText,
    jyrosSubtitle,
    homologationText,
  };
};

export default useReportCoverTexts;
